export var InteractionState;

!function(InteractionState) {
    InteractionState.default = "default", InteractionState.grabing = "grabing", InteractionState.scrolling = "scrolling";
}(InteractionState || (InteractionState = {}));

export var HighlightScope;

!function(HighlightScope) {
    HighlightScope.single = "single", HighlightScope.column = "column", HighlightScope.row = "row", 
    HighlightScope.cross = "cross", HighlightScope.none = "none";
}(HighlightScope || (HighlightScope = {}));
//# sourceMappingURL=common.js.map
